import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  creditFilter: "",
};

const CreditSettlementFilterSlice = createSlice({
  initialState: initialState,
  name: "creditsettlementFilter",
  reducers: {
    clearCreditSettlementFilter: (state) => {
      state.creditId = initialState;
    },
    setCreditSettlementFilter: (state, action) => {
      state.creditFilter = action.payload;
    },
  },
});

export const { setCreditSettlementFilter, clearCreditSettlementFilter } =
  CreditSettlementFilterSlice.actions;

export default CreditSettlementFilterSlice.reducer;
